import BasicResource from '@/api/resource';

class Resource extends BasicResource {

    constructor () {
        super('schedules');
    }

    schedules (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/schedules',
            params,
        });
    }

    offerSchedules (id, params) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/offers/${id}/schedules`,
            params,
        });
    }

    offerLinkSchedules (id, params) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/offers/link/${id}/schedules`,
            params,
        });
    }

    partnerLinkSchedules (id, params) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/partners/link/${id}/schedules`,
            params,
        });
    }

    createOffersSchedules (data) {
        return this.client.request ({
            method: 'POST',
            path: '/upyield/v1/offers/schedules',
            data,
        });
    }

    createOfferSchedules (id, data) {
        return this.client.request ({
            method: 'POST',
            path: `/upyield/v1/offers/${id}/schedules`,
            data,
        });
    }

    createOfferLinksSchedules (id, data) {
        return this.client.request ({
            method: 'POST',
            path: `/upyield/v1/offers/${id}/link/schedules`,
            data,
        });
    }

    createOfferLinkSchedules (id, data) {
        return this.client.request ({
            method: 'POST',
            path: `/upyield/v1/offers/link/${id}/schedules`,
            data,
        });
    }

    createPartnerLinksSchedules (id, data) {
        return this.client.request ({
            method: 'POST',
            path: `/upyield/v1/partners/${id}/link/schedules`,
            data,
        });
    }

    createPartnerLinkSchedules (id, data) {
        return this.client.request ({
            method: 'POST',
            path: `/upyield/v1/partners/link/${id}/schedules`,
            data,
        });
    }

    deleteSchedule (scheduleId) {
        return this.client.request ({
            method: 'DELETE',
            path: `/upyield/v1/schedules/${scheduleId}`,
        });
    }

    deleteOfferSchedule (offerId, scheduleId) {
        return this.client.request ({
            method: 'DELETE',
            path: `/upyield/v1/offers/${offerId}/schedules/${scheduleId}`,
        });
    }

    deleteLinkSchedule (linkId, scheduleId) {
        return this.client.request ({
            method: 'DELETE',
            path: `/upyield/v1/offers/link/${linkId}/schedules/${scheduleId}`,
        });
    }

    deletePartnerLinkSchedule (linkId, scheduleId) {
        return this.client.request ({
            method: 'DELETE',
            path: `/upyield/v1/partners/link/${linkId}/schedules/${scheduleId}`,
        });
    }
}

export default new Resource;
